import { Backdrop, Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Server } from '../../services/Server';
import { textLabels } from '../../constants';

type Props = {
  url: string;
  method: string;
  params: any;
  body: any;
  properties: any;
  upload?: any;
  title?: string;
};

const SMTInfo = ({ url, method, params, body }: Props) => {
  const { URL_BASE, getFromServerWithParams, postToServerWithParams } = Server();

  const {
    data: dataFromApi = {},
    isLoading: isLoading,
    isError: isError,
    error: error,
  } = useQuery({
    queryKey: ['smt-info-', url],
    queryFn: () =>
      method === 'get' ? getFromServerWithParams(`${URL_BASE}${url}`, params) : postToServerWithParams(`${URL_BASE}${url}`, params, body),
    enabled: true,
  });

  // if (isError) {
  //   handleError(error);
  // }

  return (
    <>
      <Box sx={{ pl: 1, pr: 1 }}>
        {isLoading ? (
          <Backdrop open={true} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', width: '100%', height: '50px', position: 'relative' }}>
            <CircularProgress />
          </Backdrop>
        ) : dataFromApi && !isError ? (
          <ul>
            {Object.keys(dataFromApi)?.map((item: string) => (
              <li key={item}>
                <b>{textLabels?.[item as keyof typeof textLabels]}:</b> {dataFromApi[item as keyof typeof dataFromApi]}
              </li>
            ))}
          </ul>
        ) : (
          <>
            {(error as any)?.response?.data?.title
              ? (error as any).response?.data?.title
              : (error as any)?.response?.data?.detail?.[0].loc?.join('-') + ': ' + (error as any)?.response?.data?.detail[0].msg}
          </>
        )}
      </Box>
    </>
  );
};

export default SMTInfo;
